import { capitalize } from 'lodash';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import InitiativeFilesContainer from '../../containers/initiatives/InitiativeFilesContainer.jsx';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const InitiativeFiles = ({ initiativeId, initiativeType, slug }) => {
  const title = `${capitalize(initiativeType)} Linked Files`;

  return (
    <>
      <Helmet>
        <title>{title} | ChangeSync</title>
      </Helmet>
      <InitiativeFilesContainer
        initiativeId={initiativeId}
        initiativeType={initiativeType}
        slug={slug}
      />
    </>
  );
};

InitiativeFiles.getInitialProps = ({ query }) => ({
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  slug: query.slug,
});

export default requireAuth(withRouterParams(InitiativeFiles));
